// extracted by mini-css-extract-plugin
export default {"breadcrumb":"styles_breadcrumb__-70oc","breadcrumbItem":"styles_breadcrumbItem__9ooGO","breadcrumbItemLink":"styles_breadcrumbItemLink__kI8DG"};